import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { cloneElement } from "react";
import { isElement } from "./auth-service-tools175.js";
import { getDefaultZIndex } from "./auth-service-tools182.js";
import { getRadius } from "./auth-service-tools185.js";
import { getRefProp } from "./auth-service-tools190.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { useMantineTheme } from "./auth-service-tools196.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { getStyleObject } from "./auth-service-tools243.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { OptionalPortal } from "./auth-service-tools275.js";
import { useFloatingTooltip } from "./auth-service-tools432.js";
import classes from "./auth-service-tools429.js";
import { useMergedRef } from "./auth-service-tools278.js";
const defaultProps = {
  refProp: "ref",
  withinPortal: true,
  offset: 10,
  defaultOpened: false,
  position: "right",
  zIndex: getDefaultZIndex("popover")
};
const varsResolver = createVarsResolver((theme, _ref) => {
  let {
    radius,
    color
  } = _ref;
  return {
    tooltip: {
      "--tooltip-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--tooltip-bg": color ? getThemeColor(color, theme) : void 0,
      "--tooltip-color": color ? "var(--mantine-color-white)" : void 0
    }
  };
});
const TooltipFloating = factory((_props, ref) => {
  var _a, _b;

  const props = useProps("TooltipFloating", defaultProps, _props);
  const {
    children,
    refProp,
    withinPortal,
    style,
    className,
    classNames,
    styles,
    unstyled,
    radius,
    color,
    label,
    offset,
    position,
    multiline,
    zIndex,
    disabled,
    defaultOpened,
    variant,
    vars,
    portalProps,
    ...others
  } = props;
  const theme = useMantineTheme();
  const getStyles = useStyles({
    name: "TooltipFloating",
    props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    rootSelector: "tooltip",
    vars,
    varsResolver
  });
  const {
    handleMouseMove,
    x,
    y,
    opened,
    boundaryRef,
    floating,
    setOpened
  } = useFloatingTooltip({
    offset,
    position,
    defaultOpened
  });

  if (!isElement(children)) {
    throw new Error("[@mantine/core] Tooltip.Floating component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported");
  }

  const targetRef = useMergedRef(boundaryRef, getRefProp(children), ref);

  const onMouseEnter = event => {
    var _a2, _b2;

    (_b2 = (_a2 = children.props).onMouseEnter) == null ? void 0 : _b2.call(_a2, event);
    handleMouseMove(event);
    setOpened(true);
  };

  const onMouseLeave = event => {
    var _a2, _b2;

    (_b2 = (_a2 = children.props).onMouseLeave) == null ? void 0 : _b2.call(_a2, event);
    setOpened(false);
  };

  return /* @__PURE__ */jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx(OptionalPortal, { ...portalProps,
      withinPortal,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...others,
        ...getStyles("tooltip", {
          style: { ...getStyleObject(style, theme),
            zIndex,
            display: !disabled && opened ? "block" : "none",
            top: (_a = y && Math.round(y)) != null ? _a : "",
            left: (_b = x && Math.round(x)) != null ? _b : ""
          }
        }),
        variant,
        ref: floating,
        mod: {
          multiline
        },
        children: label
      })
    }), /*#__PURE__*/cloneElement(children, { ...children.props,
      [refProp]: targetRef,
      onMouseEnter,
      onMouseLeave
    })]
  });
});
TooltipFloating.classes = classes;
TooltipFloating.displayName = "@mantine/core/TooltipFloating";
export { TooltipFloating };